"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findArchives = exports.isArchive = exports.createDepGraphFromArchives = exports.createDepGraphFromArchive = void 0;
const tslib_1 = require("tslib");
const dep_graph_1 = require("@snyk/dep-graph");
const path = require("path");
const crypto = require("crypto");
const fs = require("fs");
const glob = require("glob");
const needle = require("needle");
const debugLib = require("debug");
const debug = debugLib('snyk-mvn-plugin');
// Using the maven-central sha1 checksum API call (see: https://search.maven.org/classic/#api)
const MAVEN_SEARCH_URL = process.env.MAVEN_SEARCH_URL || 'https://search.maven.org/solrsearch/select';
const ALGORITHM = 'sha1';
const DIGEST = 'hex';
function getSha1(buf) {
    return crypto
        .createHash(ALGORITHM)
        .update(buf)
        .digest(DIGEST);
}
function getMavenDependency(targetPath) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const contents = fs.readFileSync(targetPath);
        const sha1 = getSha1(contents);
        const { g, a, v } = yield getMavenPackageInfo(sha1, targetPath);
        return {
            groupId: g,
            artifactId: a,
            version: v,
        };
    });
}
function getDependencies(paths) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const dependencies = [];
        for (const p of paths) {
            try {
                const dependency = yield getMavenDependency(p);
                dependencies.push(dependency);
            }
            catch (err) {
                // log error and continue with other paths
                console.error(`Failed to get maven dependency for '${p}'.`, err.message);
            }
        }
        return dependencies;
    });
}
function createDepGraphFromArchive(root, targetPath) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            return yield createDepGraphFromArchives(root, [targetPath]);
        }
        catch (err) {
            const msg = `There was a problem generating a dep-graph for '${targetPath}'.`;
            debug(msg, err);
            throw new Error(msg + ' ' + err.message);
        }
    });
}
exports.createDepGraphFromArchive = createDepGraphFromArchive;
function createDepGraphFromArchives(root, archivePaths) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            const dependencies = yield getDependencies(archivePaths);
            if (!dependencies.length) {
                throw new Error(`No Maven artifacts found when searching ${MAVEN_SEARCH_URL}`);
            }
            debug(`Creating dep-graph from ${JSON.stringify(dependencies)}`);
            const rootDependency = getRootDependency(root);
            const rootPkg = {
                name: `${rootDependency.groupId}:${rootDependency.artifactId}`,
                version: rootDependency.version,
            };
            const builder = new dep_graph_1.DepGraphBuilder({ name: 'maven' }, rootPkg);
            for (const dependency of dependencies) {
                const nodeId = `${dependency.groupId}:${dependency.artifactId}@${dependency.version}`;
                builder.addPkgNode({
                    name: `${dependency.groupId}:${dependency.artifactId}`,
                    version: dependency.version,
                }, nodeId);
                builder.connectDep(builder.rootNodeId, nodeId);
            }
            const depGraph = builder.build();
            debug(`Created dep-graph ${JSON.stringify(depGraph.toJSON())}`);
            return depGraph;
        }
        catch (err) {
            const msg = `Detected supported file(s) in '${root}', but there was a problem generating a dep-graph.`;
            debug(msg, err);
            throw new Error(msg + ' ' + err.message);
        }
    });
}
exports.createDepGraphFromArchives = createDepGraphFromArchives;
function isArchive(file) {
    return !!file.match(/\.(([jwa]ar)|(zip))$/);
}
exports.isArchive = isArchive;
function findArchives(targetPath, recursive = false) {
    const stats = fs.statSync(targetPath);
    const dir = stats.isFile() ? path.dirname(targetPath) : targetPath;
    return glob.sync(`${dir}/${recursive ? '**/' : ''}*.@(jar|war|aar|zip)`);
}
exports.findArchives = findArchives;
function getMavenPackageInfo(sha1, targetPath) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const url = `${MAVEN_SEARCH_URL}?q=1:"${sha1}"&wt=json`;
        return new Promise((resolve, reject) => {
            needle.request('get', url, {}, { json: true }, (err, fullRes, res) => {
                if (err) {
                    reject(err);
                }
                if (!res || !res.response || res.response.docs.length === 0) {
                    reject(new Error(`No package found querying '${MAVEN_SEARCH_URL}' for sha1 hash '${sha1}'.`));
                }
                if (res.response.docs.length > 1) {
                    const sha1Target = path.parse(targetPath).base;
                    debug('Got multiple results for sha1, looking for', sha1Target);
                    const foundPackage = res.response.docs.find(({ g }) => sha1Target.includes(g));
                    res.response.docs = [foundPackage || res.response.docs[0]];
                }
                resolve(res.response.docs[0]);
            });
        });
    });
}
function getRootDependency(root, targetFile) {
    let groupId;
    if (targetFile) {
        groupId = path.dirname(targetFile);
        if (groupId === '.') {
            // we are in directory of the jar
            groupId = path.basename(path.resolve(root));
        }
    }
    else {
        // take root's parent directory base name
        groupId = path.basename(path.dirname(path.resolve(root)));
    }
    // replace path separators with dots
    groupId = groupId
        .replace(/\//g, '.') // *inx
        .replace(/\\/g, '.') // windows
        .replace(/^\./, ''); // remove any leading '.'
    return {
        groupId: groupId || 'root',
        artifactId: path.basename(targetFile || root) || 'root',
        version: '1.0.0',
    };
}
//# sourceMappingURL=archive.js.map